import { TranslateService } from '@ngx-translate/core';
import { ICountriesResponse, ICreateCountryRequest } from '../dtos';
import { UpdateCountryModel } from './update-countries.model';
import { AllInputTypes, FormInputConfig } from '../../../../../trash/shared/interfaces/form-input-config';
import { Validators } from '@angular/forms';
import { patterns } from '../../../../../lib/formly/patterns';

export class CreateCountryModel implements ICreateCountryRequest {
  referenceId: number;
  englishName: string;
  arabicName: string;
  isActive: boolean | undefined;
  code: string;
  phoneCode: string;
  currency: string;
  language: string;
  flag: string;

  constructor(request: ICreateCountryRequest) {
    this.referenceId = request.referenceId;
    this.englishName = request.englishName;
    this.arabicName = request.arabicName;
    this.isActive = request.isActive;
    this.code = request.code;
    this.phoneCode = request.phoneCode;
    this.currency = request.currency;
    this.language = request.language;
    this.flag = request.flag;
  }

  static create(data: ICreateCountryRequest): CreateCountryModel {
    return new CreateCountryModel(data);
  }

  static createDefault(): CreateCountryModel {
    return CreateCountryModel.create({
      referenceId: 0,
      englishName: '',
      arabicName: '',
      isActive: true,
      code: '',
      phoneCode: '',
      currency: '',
      language: '',
      flag: ''
    });
  }

  static createFromItem(item: ICountriesResponse): CreateCountryModel {
    return new CreateCountryModel({
      referenceId: item.referenceId,
      englishName: item.englishName,
      arabicName: item.arabicName,
      isActive: item.isActive,
      code: item.code,
      phoneCode: item.phoneCode,
      currency: item.currency,
      language: item.language,
      flag: item.flag
    });
  }

  getFormConfig(isVisible?: boolean, translate?: TranslateService): FormInputConfig[] {
    return [
      // getIdFormConfig(this.id),
      {
        type: AllInputTypes.Text,
        name: 'englishName',
        label: translate?.instant('LOCATION_MANAGEMENT.COUNTRY_ENGLISH_NAME'),
        placeholder: `${translate?.instant('FORMS.EX')} ${translate?.instant('LOCATION_MANAGEMENT.COUNTRY_ENGLISH_NAME')}`,
        defaultValue: this.englishName,
        isDisable: !isVisible,
        widthClass: 'col-12',
        validation: [
          {
            function: Validators.required,
            errorMessage: `${translate?.instant('GENERAL.PLEASE_ENTER')} ${translate?.instant('LOCATION_MANAGEMENT.COUNTRY_ENGLISH_NAME')}`
          },
          {
            function: Validators.pattern(patterns.onlyEnglishCharacters),
            errorMessage: translate?.instant('SERVICE_MANAGEMENT.VALIDATION_ONLY_ENGLISH'),
            errorName: 'pattern'
          }
        ]
      },
      {
        type: AllInputTypes.Text,
        name: 'arabicName',
        label: translate?.instant('LOCATION_MANAGEMENT.COUNTRY_ARABIC_NAME'),
        placeholder: `${translate?.instant('FORMS.EX')} ${translate?.instant('LOCATION_MANAGEMENT.COUNTRY_ARABIC_NAME')}`,
        defaultValue: this.arabicName,
        isDisable: !isVisible,
        widthClass: 'col-12',
        validation: [
          {
            function: Validators.required,
            errorMessage: `${translate?.instant('GENERAL.PLEASE_ENTER')} ${translate?.instant('LOCATION_MANAGEMENT.COUNTRY_ARABIC_NAME')}`
          },
          {
            function: Validators.pattern(patterns.onlyArabicCharacters),
            errorMessage: translate?.instant('SERVICE_MANAGEMENT.VALIDATION_ONLY_ARABIC'),
            errorName: 'pattern'
          }
        ]
      },
      {
        type: AllInputTypes.Text,
        name: 'code',
        label: translate?.instant('LOCATION_MANAGEMENT.CODE'),
        placeholder: `${translate?.instant('FORMS.EX')} ${translate?.instant('LOCATION_MANAGEMENT.CODE')}`,
        defaultValue: this.code,
        isDisable: !isVisible,
        widthClass: 'col-12',
        validation: [
          {
            function: Validators.required,
            errorMessage: `${translate?.instant('GENERAL.PLEASE_ENTER')} ${translate?.instant('LOCATION_MANAGEMENT.CODE')}`
          }
        ]
      },
      {
        type: AllInputTypes.Text,
        name: 'phoneCode',
        label: translate?.instant('LOCATION_MANAGEMENT.PHONE_CODE'),
        placeholder: `${translate?.instant('FORMS.EX')} ${translate?.instant('LOCATION_MANAGEMENT.PHONE_CODE')}`,
        defaultValue: this.phoneCode,
        isDisable: !isVisible,
        widthClass: 'col-12',
        validation: [
          {
            function: Validators.required,
            errorMessage: `${translate?.instant('GENERAL.PLEASE_ENTER')} ${translate?.instant('LOCATION_MANAGEMENT.PHONE_CODE')}`
          }
        ]
      },
      {
        type: AllInputTypes.Text,
        name: 'currency',
        label: translate?.instant('LOCATION_MANAGEMENT.CURRENCY'),
        placeholder: `${translate?.instant('FORMS.EX')} ${translate?.instant('LOCATION_MANAGEMENT.CURRENCY')}`,
        defaultValue: this.currency,
        isDisable: !isVisible,
        widthClass: 'col-12',
        validation: [
          {
            function: Validators.required,
            errorMessage: `${translate?.instant('GENERAL.PLEASE_ENTER')} ${translate?.instant('LOCATION_MANAGEMENT.CURRENCY')}`
          }
        ]
      },
      {
        type: AllInputTypes.Text,
        name: 'language',
        label: translate?.instant('LOCATION_MANAGEMENT.LANGUAGE'),
        placeholder: `${translate?.instant('FORMS.EX')} ${translate?.instant('LOCATION_MANAGEMENT.LANGUAGE')}`,
        defaultValue: this.language,
        isDisable: !isVisible,
        widthClass: 'col-12',
        validation: [
          {
            function: Validators.required,
            errorMessage: `${translate?.instant('GENERAL.PLEASE_ENTER')} ${translate?.instant('LOCATION_MANAGEMENT.LANGUAGE')}`
          }
        ]
      },
      {
        type: AllInputTypes.Text,
        name: 'flag',
        label: translate?.instant('LOCATION_MANAGEMENT.FLAG'),
        placeholder: `${translate?.instant('FORMS.EX')} ${translate?.instant('LOCATION_MANAGEMENT.FLAG')}`,
        defaultValue: this.flag,
        isDisable: !isVisible,
        widthClass: 'col-12',
        validation: [
          {
            function: Validators.required,
            errorMessage: `${translate?.instant('GENERAL.PLEASE_ENTER')} ${translate?.instant('LOCATION_MANAGEMENT.FLAG')}`
          }
        ]
      },
      {
        type: AllInputTypes.ToggleButton,
        name: 'isActive',
        label: translate?.instant('GENERAL.STATUS'),
        defaultValue: this.isActive ?? true,
        isDisable: !isVisible,
        widthClass: 'col-12'
      }
    ];
  }
}
